import { AddNewLocation } from "./AddNewLocation";

export default AddNewLocation;
